import AsyncStorage from '@react-native-async-storage/async-storage';
import React, { createContext, useState } from 'react';

export interface Bookmark {
    partIndex: number;
    sectionIndex: number;
    paragraphIndex: number;
    paragraphNumber: number;
    sectionName: string;
}

interface IAppContext {
    bookmark: Bookmark|null;
    bgColor: string;
    setBookmark: (bookmark: Bookmark|null) => void;
    setBgColor: (color: string) => void;
    saveBookmark: (partIndex: number, sectionIndex: number, paragraphIndex: number, paragraphNumber: number, sectionName: string) => Promise<boolean>;
    getBookmark: () => Promise<Bookmark|null>;
}

const AppContext = createContext<IAppContext>({
    bookmark: null,
    bgColor: '#fff',
    setBookmark: (bookmark: Bookmark|null) => {console.log()},
    setBgColor: (color: string) => {console.log()},
    saveBookmark: async (partIndex: number, sectionIndex: number, paragraphIndex: number, paragraphNumber: number, sectionName: string) => true,
    getBookmark: async () => null,
});

const AppProvider: React.FC = ({ children }) => {
    const [bookmark, setBookmark] = useState<Bookmark|null>(null);
    const [bgColor, setBgColor] = useState('#fff');

    async function saveBookmark(partIndex: number, sectionIndex: number, paragraphIndex: number, paragraphNumber: number, sectionName: string) {
        const newBookmark: Bookmark = {
            partIndex,
            sectionIndex,
            paragraphIndex,
            paragraphNumber,
            sectionName
        };
        console.log(newBookmark); 

        await AsyncStorage.setItem('bookmark', JSON.stringify(newBookmark));

        setBookmark(newBookmark);

        return true;
    }

    async function getBookmark() {
        const response = await AsyncStorage.getItem('bookmark');

        if (response) {
            const currentBookmark: Bookmark = JSON.parse(response);
            return currentBookmark;
        }

        return null;
    } 

    return (
        <AppContext.Provider
            value={{
                bookmark,
                setBookmark,
                saveBookmark,
                getBookmark,
                bgColor,
                setBgColor
            }} 
        >
            {children}
        </AppContext.Provider>
    );
}

export { AppContext, AppProvider };